import ActivityListItem from "@components/ActivityListItem/ActivityListItem";
import { ActivityItem } from "../../types/activity";
import ActivityListSkeleton from "./ActivityListSkeleton";
import EmptyList from "@components/EmptyList/EmptyList";
import { Container, EmptyContainer, ItemContainer, Divider } from "./ActivityList.styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

type ActivityListProps = {
    activities: ActivityItem[];
    isLoading: boolean;
    onItemClick: (activity: ActivityItem) => void;
}

const ActivityList = ({ activities, isLoading, onItemClick }: ActivityListProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (isLoading === true) {
        return <ActivityListSkeleton />;
    }

    if (isLoading === false && (activities === undefined || activities.length === 0)) {
        return (
            <EmptyContainer>
                <EmptyList
                    text={t('components.activityList.emptyText')}
                    pressableText={t('components.activityList.topUpText')}
                    onPress={() => navigate('/top-up-method')}
                />
            </EmptyContainer>
        );
    }

    return (
        <Container>
            {activities.map((activity, index) => {
                return (
                    <ItemContainer
                        key={activity.uuid + 'container'}
                    >
                        <ActivityListItem
                            key={activity.uuid + 'item'}
                            uuid={activity.uuid}
                            transaction_uuid={activity.transaction_uuid}
                            code={activity.code}
                            status={activity.status}
                            timestamp={activity.timestamp}
                            ui_amount={activity.ui_amount}
                            unit={activity.unit}
                            onClick={() => onItemClick(activity)}
                        />
                        {index !== activities.length - 1 && <Divider />}
                    </ItemContainer>
                )
            })}
        </Container>
    )
}

export default ActivityList